/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Focus_Segment_DescriptionInputs */

const en_export_power_point_focus_segment_description = /** @type {(inputs: Export_Power_Point_Focus_Segment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certain content will only be exported for the focus segment.`)
};

const de_export_power_point_focus_segment_description = /** @type {(inputs: Export_Power_Point_Focus_Segment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmte Inhalte werden nur für das Fokussegment exportiert.`)
};

/**
* | output |
* | --- |
* | "Certain content will only be exported for the focus segment." |
*
* @param {Export_Power_Point_Focus_Segment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_focus_segment_description = /** @type {((inputs?: Export_Power_Point_Focus_Segment_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Focus_Segment_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_focus_segment_description(inputs)
	return de_export_power_point_focus_segment_description(inputs)
});